import React, { useState, useCallback } from "react";
import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import AddComment from "@mui/icons-material/AddComment";
import { styled } from "@mui/material/styles";

import { useProfile } from "../DataHooks/useProfile";
import { fetchHandleError } from "../../helpers/fetchHandleError";
import { getFormData } from "../../helpers/methods";

const Root = styled(Paper)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  marginBottom: "5em",
}));

const StyledInput = styled(InputBase)(({ theme }) => ({
  marginLeft: theme.spacing(1),
  flex: 1,
}));

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  padding: 10,
}));

const StyledDivider = styled(Divider)(({ theme }) => ({
  height: 28,
  margin: 4,
}));

const AddCommentComp = ({ video }) => {
  const [value, setValue] = useState("");
  const { profile } = useProfile();

  const onChangeHandler = useCallback((e) => setValue(e.target.value), []);
  const onClickAdd = useCallback(() => {
    const data = getFormData({ message: value });
    fetch(
      `${process.env.REACT_APP_GRAPH_API_URL}/${video.id}/comments?access_token=${profile.page.token}`,
      {
        method: "post",
        body: data,
      }
    )
      .then(fetchHandleError)
      .then((resp) => {})
      .catch((e) => {
        alert(e);
      });
    setValue("");
  }, [profile, value, video]);

  return (
    <Root component="div">
      <StyledInput
        multiline
        placeholder="yada yada..."
        inputProps={{ "aria-label": "Add comment" }}
        onChange={onChangeHandler}
        value={value}
      />
      <StyledDivider orientation="vertical" />
      <StyledIconButton
        color="primary"
        disabled={!value.trim()}
        onClick={onClickAdd}
      >
        <AddComment />
      </StyledIconButton>
    </Root>
  );
};

export default AddCommentComp;
